import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbfbfee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relation" }

import { computed } from "vue";
import { startCase } from "lodash";
import { Association } from "@/api/node-associations";

interface Props {
  /** current relation */
  relation: Pick<Association["relation"], "iri" | "name" | "inverse">;
  /** whether to display arrows vertically */
  vertical?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRelationBadge',
  props: {
    relation: null,
    vertical: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  /** current relation */
  relation: Pick<Association["relation"], "iri" | "name" | "inverse">;
  /** whether to display arrows vertically */
  vertical?: boolean;
}



/** direction of arrows */
const arrowDirection = computed(() => {
  if (props.vertical) {
    if (props.relation.inverse) return "up";
    else return "down";
  } else {
    if (props.relation.inverse) return "left";
    else return "right";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLink = _resolveComponent("AppLink")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_AppIcon, {
      class: "arrow",
      icon: `arrow-${_unref(arrowDirection)}-long`
    }, null, 8, ["icon"]),
    _createVNode(_component_AppLink, {
      to: __props.relation.iri,
      "no-icon": true
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(startCase)(__props.relation.name)), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_AppIcon, {
      class: "arrow",
      icon: `arrow-${_unref(arrowDirection)}-long`
    }, null, 8, ["icon"])
  ]))
}
}

})